import React from "react";
import classNames from "classnames/bind";
import LaunchIcon from "@material-ui/icons/Launch";
import s from "./ListComponent.module.scss";
import { IconButton, Tooltip } from "@material-ui/core";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";

const ListComponent = (props) => {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  const projects = props.data || [];
  const getListHeader = (item) => (
    <div className={cx(classes.primaryThemeColor, "bold", s.listHeading)}>
      <span>{item.title}</span>
      {item.projectLink && (
        <IconButton
          className={classes.iconDetailOverride}
          edge="end"
          aria-label="project link"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={() => window.open(item.projectLink, "_blank")}
          color="inherit"
        >
          <Tooltip title={item.projectLink} aria-label="project link">
            <LaunchIcon className={classes.iconDetailOverride} />
          </Tooltip>
        </IconButton>
      )}
    </div>
  );

  const getItemRoles = (item) => (
    <section className={s.roles}>
      {item.roles.length > 0 && (
        <div className={cx(classes.secondaryTextColor, "bold", s.roleHeading)}>
          Roles:
        </div>
      )}
      <ul>
        {item.roles.map((role, index) => (
          <li className={classes.role} key={index}>
            {role.title && <span className="bold">{role.title} : </span>}
            <span>{role.description}</span>
          </li>
        ))}
      </ul>
    </section>
  );

  return (
    <section className={cx(s.listContainer, classes.secondaryTextColor)}>
      {projects.map((item, index) => (
        <div key={index} className={cx(s.project, classes.project)}>
          {getListHeader(item)}
          <span className={s.description}>{item.description}</span>
          {item.roles && getItemRoles(item)}
        </div>
      ))}
    </section>
  );
};

export default ListComponent;

const compClasses = (theme) => ({
  project: {
    "&:before": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  role: {
    "&:before": {
      backgroundColor: theme.palette.text.secondary,
    },
  },
  iconDetailOverride: {
    height: "0.7em",
    width: "0.7em",
    padding: "0px",
  },
});
